import EventEmitter from 'eventemitter3';
import { uid } from '../../../../utils/data/uid.mjs';

"use strict";
class TextureView extends EventEmitter {
  /**
   * @param source - The texture source to view.
   * @param viewDescriptor - The WebGPU texture view descriptor.
   */
  constructor(source, viewDescriptor) {
    super();
    /** The type of resource this is (for BindGroup compatibility). */
    this._resourceType = "textureView";
    /** Unique ID for this resource. */
    this._resourceId = uid("resource");
    this.source = source;
    this.viewDescriptor = viewDescriptor;
    this._onChange = this._onChange.bind(this);
    this._onDestroy = this._onDestroy.bind(this);
    this.source.on("change", this._onChange);
    this.source.on("destroy", this._onDestroy);
  }
  _onChange() {
    this.emit("change", this);
  }
  _onDestroy() {
    this.destroy();
  }
  /** Returns whether the underlying source is destroyed. */
  get destroyed() {
    return this.source.destroyed;
  }
  /** Destroys the view and cleans up event listeners. */
  destroy() {
    if (this.source) {
      this.source.off("change", this._onChange);
      this.source.off("destroy", this._onDestroy);
    }
    this.emit("destroy", this);
    this.removeAllListeners();
  }
}

export { TextureView };
//# sourceMappingURL=TextureView.mjs.map
